/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

/* EasyWholesale Custom Start */
function nm_easywholesale_custom_script() {
  document.querySelectorAll('.nm-easywholesale-item').forEach( item => {
    let colorSwitcherContainer = document.querySelector('.variant-button-wrap');
    if (colorSwitcherContainer) {
      let color = item.getAttribute('data-option1');
      let colorSwitcher = document.querySelector(`.variant-button-wrap .visually-hidden[value="${color}"]`).nextElementSibling.cloneNode(true);
      let imgContainer = item.querySelector('.nm-easywholesale-img');
        item.classList.add("variant-button-wrap");
        imgContainer.innerHTML = '';
        imgContainer.append(colorSwitcher);
    }
  })
  if(window.location.href.indexOf('/es/') !== -1 
     || window.location.href.indexOf('.mx') !== -1 && window.location.href.indexOf('.mx/en/') == -1
     || window.location.href.indexOf('.es') !== -1 && window.location.href.indexOf('.es/en/') == -1){
    document.querySelectorAll('.nm-easywholesale-form a[href="/account/login"]').forEach(el => {
      el.textContent = 'acceso para precio';
    });
    document.querySelectorAll('.nm-wholesale-btn-add-to-cart').forEach(el => {
      el.textContent = 'Añadir a la cesta';
    }) 
    document.querySelectorAll('.nm-easywholesale-footer .nm-easywholesale-selected').forEach(el => {
      el.innerHTML = `Productos totales: <span id="nm-total-selected-items" class="nm-total-selected-items">0</span>`;
    })
    document.querySelector('.nm-wholesale-show-more-variants').textContent = 'Mostrar más opciones';    
    document.querySelector('.nm-wholesale-show-more-variants').addEventListener("click", textTranslate);
    
    document.querySelector('.nm-wholesale-collapse').textContent = 'Colapsar';
    document.querySelector('.nm-wholesale-collapse').addEventListener("click", textTranslate);
    
    function textTranslate() {
      document.querySelector('.nm-wholesale-show-more-variants').textContent = 'Mostrar más opciones';
    }
  } 
  document.querySelectorAll('.nm-easywholesale-name-and-price .nm-easywholesale-name-and-price-only').forEach(name_price_container => {
    if( name_price_container.querySelector('.nm-easywholesale-price')){
      let easyMetafield = document.createElement('div');
      easyMetafield.classList.add('easyMetafield');
      easyMetafield.textContent = document.querySelector('.hideBlock.easyMetafield').textContent;
      const name = name_price_container.querySelector('.nm-easywholesale-name');
      name.parentNode.insertBefore(easyMetafield, name.nextSibling); 
    }
  })
}
/* EasyWholesale Custom Finish */